export default __webpack_public_path__ + "static/media/separator.aca43fc3.svg";